import React from 'react';
import "./CardRenderer.css"
import { formatTimestamp } from './Utils';
import { useNavigate } from 'react-router-dom';

function CardRenderer({post, width="90vw", component=""}) {
  const navigate = useNavigate()
  function getIdFromQuery() {
  const params = new URLSearchParams(window.location.search);
  return params.get('id');
}
  
    return (
      
        <div className={getIdFromQuery()===post.id?"card cardSelected":"card"} onClick={()=>{navigate(component===""?window.location.pathname+"?id="+post.id:"/"+component+"?id="+post.id)}} style={{backgroundColor: post.selectedPostId && post.selectedPostId === post.id ? "#33a2ff": "#fff" }}>
    <div>
    <img
      src={post?.image?.length>2?post.image: "https://corporatenridata.s3.us-west-1.amazonaws.com/professional_collage_variation.jpg"}
      className="image"
      alt={post?.title || "Post image"}
    />
    </div>
    <div className="content">
    <div className="cardHeader">
    {/* <img
      src={"https://corporatenridata.s3.us-west-1.amazonaws.com/professional_collage_variation.jpg"}
      style={{height: "30px", margin:"auto 0px"}}
    /> */}
        <div>
        <p className="title">{post?.title}</p>
        <div className="status">
        <p style={{ color: 'green', fontSize:"14px", whiteSpace: 'nowrap' }}>{post?.price}</p>  |   <p style={{ color: "blue", fontSize:"14px"}}>{post?.location}</p>
      </div>
      </div>
      </div>
      {component==="latest"&&<>
      {post.category !==3 ? <div className="features" >
       {post?.amenities?.slice(0,3).map((feature, index) => (
          <p key={index} className="featureBadge">{feature}</p>
        ))}
        {post?.amenities?.length>3&&<p key={4} className="featureBadge">+{post?.amenities.length-3}</p>}
      </div> : <p className="featureBadge" style={{backgroundColor:"transparent"}} ></p>}
      </>}
      <div className="cardFooter">
  
  {/* {post.location!=="search" && <> */}
  <p className="time">posted by: {post?.postedBy}</p>
  <p className="time">{formatTimestamp(post?.createdAt)}</p>
  {/* </>} */}
</div>
    </div>
  </div>
    );
}

export default CardRenderer;